module.exports = __webpack_public_path__ + "static/media/pic2.5a4117b3.jpg";